var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18.25583,
    height: 18.24196,
    viewBox: "949.5,486,18.25583,18.24196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#005591",
    fillRule: "none",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M964.07128,502.48928v-1.73571c0,-1.19764 -0.48085,-2.2842 -1.25484,-3.06874c-0.77399,-0.78454 -1.84798,-1.27054 -3.03083,-1.27054h-5.99994c-1.18284,0 -2.25598,0.48687 -3.03083,1.27054c-0.77485,0.78368 -1.25484,1.8711 -1.25484,3.06874v1.73571c0,0.47906 0.384,0.86786 0.85713,0.86786c0.47314,0 0.85713,-0.3888 0.85713,-0.86786v-1.73571c0,-0.71945 0.28714,-1.36861 0.75342,-1.84073c0.46628,-0.47211 1.10742,-0.76285 1.81798,-0.76285h5.99994c0.71056,0 1.3517,0.29073 1.81798,0.76285c0.46628,0.47211 0.75342,1.12127 0.75342,1.84073v1.73571c0,0.47906 0.384,0.86786 0.85713,0.86786c0.47314,0 0.85713,-0.3888 0.85713,-0.86786zM961.07131,490.33928c0,-1.19764 -0.48085,-2.2842 -1.25484,-3.06874c-0.77399,-0.78454 -1.84798,-1.27054 -3.03083,-1.27054c-1.18284,0 -2.25598,0.48687 -3.03083,1.27054c-0.77485,0.78368 -1.25484,1.8711 -1.25484,3.06874c0,1.19764 0.48085,2.2842 1.25484,3.06874c0.77399,0.78454 1.84798,1.27054 3.03083,1.27054c1.18284,0 2.25598,-0.48687 3.03083,-1.27054c0.77485,-0.78368 1.25484,-1.8711 1.25484,-3.06874zM959.35704,490.33928c0,0.71945 -0.28714,1.36861 -0.75342,1.84072c-0.46628,0.47211 -1.10742,0.76285 -1.81798,0.76285c-0.71056,0 -1.3517,-0.29073 -1.81798,-0.76285c-0.46628,-0.47211 -0.75342,-1.12127 -0.75342,-1.84072c0,-0.71945 0.28714,-1.36861 0.75342,-1.84073c0.46628,-0.47211 1.10742,-0.76285 1.81798,-0.76285c0.71056,0 1.3517,0.29073 1.81798,0.76285c0.46628,0.47211 0.75342,1.12127 0.75342,1.84073z",
    id: "CompoundPath 1",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M967.11332,493.59931l-0.8588,-0.86261c-0.78628,-0.79009 -2.00132,-0.79009 -2.7876,0l-1.43006,1.50767l3.64513,3.66039l1.50131,-1.50767c0.36028,-0.36281 0.56555,-0.85137 0.57253,-1.36263c0,-0.50256 -0.28627,-1.07763 -0.64251,-1.43642",
    id: "Path 1",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M964.5026,497.35402l-2.79877,-2.80998l-5.52779,5.55021c-0.35,0.35249 -0.5605,0.84324 -0.5605,1.40624v2.17848c0,0.2815 0.2105,0.56299 0.5605,0.56299h2.23951c0.49075,0 0.97901,-0.2105 1.40001,-0.56299l5.52779,-5.55145z",
    id: "Path 1",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0cb124baa230e7368513e7504b44c049.svg";
export { ForwardRef as ReactComponent };